"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWaybackSubDomains = exports.getWaybackConfigFileURL = exports.getTileImageURL = exports.getWaybackServiceBaseURL = exports.setDefaultWaybackOptions = exports.WAYBACK_SERVICE_URL_TEMPLATE = exports.WAYBACK_SERVICE_SUB_DOMAINS_DEV = exports.WAYBACK_SERVICE_SUB_DOMAINS_PROD = void 0;
/**
 * An array of subDomain names for production wayback service.
 * Using different subDomains helps to speed up tile retrieval.
 */
exports.WAYBACK_SERVICE_SUB_DOMAINS_PROD = [
    'wayback',
    'wayback-a',
    'wayback-b',
];
/**
 * An array of subDomain names for development wayback service.
 */
exports.WAYBACK_SERVICE_SUB_DOMAINS_DEV = ['waybackdev'];
/**
 * The template of the wayback service root URL.
 */
exports.WAYBACK_SERVICE_URL_TEMPLATE = 'https://{subDomain}.maptiles.arcgis.com/arcgis/rest/services/World_Imagery/MapServer';
// const WAYBACK_SERVICE_BASE_PROD =
//     'https://wayback.maptiles.arcgis.com/arcgis/rest/services/World_Imagery/MapServer';
// const WAYBACK_SERVICE_BASE_DEV =
//     'https://waybackdev.maptiles.arcgis.com/arcgis/rest/services/World_Imagery/MapServer';
const WAYBACK_CONFIG_FILE_PROD = 'https://s3-us-west-2.amazonaws.com/config.maptiles.arcgis.com/waybackconfig.json';
const WAYBACK_CONFIG_FILE_DEV = 'https://s3-us-west-2.amazonaws.com/config.maptiles.arcgis.com/dev/waybackconfig.json';
/**
 * if true, use dev wayback services
 */
let shouldUseDevServices = false;
/**
 *
 * @param defaultOptions
 */
const setDefaultWaybackOptions = (defaultOptions) => {
    shouldUseDevServices = defaultOptions.useDevServices || false;
};
exports.setDefaultWaybackOptions = setDefaultWaybackOptions;
const getRandomSubDomain = () => {
    const subDomains = shouldUseDevServices
        ? exports.WAYBACK_SERVICE_SUB_DOMAINS_DEV
        : exports.WAYBACK_SERVICE_SUB_DOMAINS_PROD;
    const randomIdx = Math.floor(Math.random() * subDomains.length);
    const subDomain = subDomains[randomIdx];
    return subDomain;
};
/**
 * Generates the base URL for the Wayback service, replacing the subdomain placeholder
 * with a randomly selected subdomain from the available options.
 *
 * @returns {string} The base URL for the Wayback service with a random subdomain.
 */
const getWaybackServiceBaseURL = () => {
    const subDomain = getRandomSubDomain();
    return exports.WAYBACK_SERVICE_URL_TEMPLATE.replace('{subDomain}', subDomain);
};
exports.getWaybackServiceBaseURL = getWaybackServiceBaseURL;
/**
 * Generates the full URL to retrieve a tile image based on the provided column, row, and zoom level.
 * The function substitutes the placeholders in the URL template with the appropriate values for
 * level, row, and column, and it also replaces the subdomain placeholder with a randomly selected subdomain.
 *
 * @param {GetTileImageURLParams} params - The parameters for generating the tile image URL.
 *     - `urlTemplate`: The template URL containing placeholders for level, row, and column.
 *     - `column`: The column coordinate for the tile.
 *     - `row`: The row coordinate for the tile.
 *     - `level`: The level of detail (zoom level) for the tile.
 * @returns {string} The complete tile image URL with the correct column, row, level, and subdomain.
 */
const getTileImageURL = ({ urlTemplate = '', column = null, row = null, level = null, }) => {
    const subDomain = getRandomSubDomain();
    const url = urlTemplate
        .replace('{level}', level.toString())
        .replace('{row}', row.toString())
        .replace('{col}', column.toString());
    const subDomainToBeReplaced = shouldUseDevServices
        ? 'waybackdev'
        : 'wayback';
    return url.replace(subDomainToBeReplaced, subDomain);
};
exports.getTileImageURL = getTileImageURL;
const getWaybackConfigFileURL = () => {
    return shouldUseDevServices
        ? WAYBACK_CONFIG_FILE_DEV
        : WAYBACK_CONFIG_FILE_PROD;
};
exports.getWaybackConfigFileURL = getWaybackConfigFileURL;
/**
 * Get an array of subDomain names where tiles are served to speed up tile retrieval.
 * @returns {string[]} array of subDomain names (e.g. `[ 'wayback-a', 'wayback-b' ]`)
 *
 * @see https://developers.arcgis.com/javascript/latest/api-reference/esri-layers-WebTileLayer.html#subDomains
 */
const getWaybackSubDomains = () => {
    return shouldUseDevServices
        ? exports.WAYBACK_SERVICE_SUB_DOMAINS_DEV
        : exports.WAYBACK_SERVICE_SUB_DOMAINS_PROD;
};
exports.getWaybackSubDomains = getWaybackSubDomains;
//# sourceMappingURL=index.js.map